import React from "react";
import classNames from "classnames";
import { TransactionFiltersDto } from "@common/dto/transactions/getTransactions/transaction-filters.dto";
import { noop } from "@common/helpers/function";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { ActiveFilterButton } from "@components/pageHeader/filters/ActiveFilters/ActiveFilterButton";
import { ActiveFilterButtonLabel } from "@components/pageHeader/filters/ActiveFilterButtonLabel";
import styles from "./ActionsCard.module.scss";

interface Props {
    filters: TransactionFiltersDto;
    similarToFallbackLabel?: string;
    className?: string;
}

/**
 * Read-only summary line for drawer scope filters that are not editable in
 * the filter menu. Direction is omitted because it is shown by the amount
 * filter.
 */
export const StaticConditionsRow: React.FC<Props> = ({
    filters,
    similarToFallbackLabel,
    className,
}) => {
    if (
        !filters.normalizedDescriptionId &&
        !filters.normalizedDescriptionIds?.length
    ) {
        return null;
    }

    return (
        <div className={classNames(styles.staticConditionsLine, className)}>
            {similarToFallbackLabel ? (
                <ActiveFilterButton
                    label={
                        <BreakableText
                            text={`Similar to ${similarToFallbackLabel}`}
                            showTooltip
                        />
                    }
                    resetFilter={noop}
                    disabled
                />
            ) : (
                <ActiveFilterButtonLabel
                    filterId="similarTo"
                    filters={filters}
                    onChange={noop}
                    disabled
                />
            )}
        </div>
    );
};
